import { Kind } from 'graphql';
import type { DocumentNode } from 'graphql';

import { ensureDefined, invariant } from '@e-socna/utils';

export const getDocumentName = (document: DocumentNode): string => {
  const { firstDefinition } = ensureDefined(
    { firstDefinition: document.definitions[0] },
    'Document has no definitions',
  );

  invariant(
    firstDefinition.kind === Kind.OPERATION_DEFINITION,
    'Document has no operation definition',
  );

  const { name } = ensureDefined(
    { name: firstDefinition.name },
    'Document has no operation name',
  );

  return name.value;
};
